/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrendingPlaylistNotificationAction } from './TrendingPlaylistNotificationAction';
import {
    TrendingPlaylistNotificationActionFromJSON,
    TrendingPlaylistNotificationActionFromJSONTyped,
    TrendingPlaylistNotificationActionToJSON,
} from './TrendingPlaylistNotificationAction';

/**
 * 
 * @export
 * @interface TrendingPlaylistNotification
 */
export interface TrendingPlaylistNotification {
    /**
     * 
     * @type {string}
     * @memberof TrendingPlaylistNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof TrendingPlaylistNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrendingPlaylistNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrendingPlaylistNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<TrendingPlaylistNotificationAction>}
     * @memberof TrendingPlaylistNotification
     */
    actions: Array<TrendingPlaylistNotificationAction>;
}

/**
 * Check if a given object implements the TrendingPlaylistNotification interface.
 */
export function instanceOfTrendingPlaylistNotification(value: object): value is TrendingPlaylistNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function TrendingPlaylistNotificationFromJSON(json: any): TrendingPlaylistNotification {
    return TrendingPlaylistNotificationFromJSONTyped(json, false);
}

export function TrendingPlaylistNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendingPlaylistNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(TrendingPlaylistNotificationActionFromJSON)),
    };
}

export function TrendingPlaylistNotificationToJSON(value?: TrendingPlaylistNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(TrendingPlaylistNotificationActionToJSON)),
    };
}

